import React from 'react';
import InfoList from 'components/InfoList';
import './styles.css';

const ReviewMeta = props => {
  const { companyReviewMeta } = props;

  return (
    <div className="review-meta">
      <InfoList objectList={companyReviewMeta} />
    </div>
  );
};

ReviewMeta.propTypes = {};

export default ReviewMeta;
